import Component from '../abstracts/Component';
import vex from 'vex-js';
import DatePickerComponent from './DatePickerComponent';
import { trapFocusOnModal, removeTrapFocusOnModal, getFocusableElements } from '../utils/TrapFocus';
export default class ModalComponent extends Component {

  get SELECTORS() {
    return {
      trigger: '[data-modal]',
      container: '.vex',
      focusableEl: 'a, :input:not([type=hidden]), button, [tabindex], iframe, :input:not(.form-group__username)',
      datepicker: '.js-datepicker'
    }
  }

  get LIBRARIES_SELECTORS() {
    return {
      tab: '[data-tabs]',
      select: 'select',
      fakeSelectToCleanUp: 'select.select2-hidden-accessible + span.select2-container'
    }
  }

  get CLASSES () {
    return {
      canScroll: 'can-scroll',
      clicked: 'clicked'
    }
  }

  constructor() {
    super();
    this.focusableEl = $(this.SELECTORS.focusableEl);
    this.datePickerComponent = new DatePickerComponent;
    this.loadedComponents = [];
  }

  modalAfterOpen(vexInstance, closeText, overflow, ariaClose='') {
    let lang = this.datePickerComponent.getLocalization($('html').attr('lang'));
    this.datePickerComponent.render();
    this.datePickerComponent.initDatepicker(null, lang, this.SELECTORS.datepicker);

    let $close =  $(vexInstance.closeEl);
    let $container = $(vexInstance.rootEl);
    let closeLabel = closeText;
    $($close).removeClass('vex-close');
    $($close).addClass('icon-close');

    if (closeText) {
      $close.text(closeLabel).addClass('cta-close')
    }

    if (overflow && overflow === 'auto') {
      $('body').addClass(this.CLASSES.canScroll);
    }

    let $tabs = $container.find(this.LIBRARIES_SELECTORS.tab);
    if ($tabs.length > 0) {
      this.moduleLoader.loadBootstrapJsComponentAndExecute("tab",
        (module) => {
          $(this.LIBRARIES_SELECTORS.tab).tab();
          this.log('Tab initialized');
        },
        (error) => {
          console.log("failed to load tabs ", error.stack);
        }
      )
    }

    // let $select = $container.find(this.LIBRARIES_SELECTORS.select);

    // if ($select.length > 0) {
    //   this.moduleLoader.loadSelect2(
    //     (module) => {
    //       $container.find(this.LIBRARIES_SELECTORS.fakeSelectToCleanUp).remove()
    //       const $selectEl = $(this.LIBRARIES_SELECTORS.select);

    //       $selectEl.each(function () {
    //         let ctx =  $(this);
    //         ctx.select2({
    //           minimumResultsForSearch: Infinity
    //         });
    //       });
    //     },
    //     (error) => {
    //       console.log("failed to load select2 ", error.stack);
    //     }
    //   );
    // }

    //ADD ACCESSIBILITY PROPERTIES
    $container.attr('tabindex', -1);
    $close.attr('role', 'button').attr('tabindex', 0).attr('aria-label', ariaClose);
    // trap focus inside the modal
    this._focusTrapHandler = trapFocusOnModal($container[0]);

    let $focusableEl = $container.find(this.SELECTORS.focusableEl);
    $focusableEl.first().focus();

    document.querySelectorAll('.js-recover-shipping-address .js-forceUppercase').forEach(function (uppercaseElement) {
      uppercaseElement.addEventListener('input', function () {
        uppercaseElement.value = this.value.toUpperCase();
      });
    });

    // Event delegation to manage close modal on click
    $container.off('keydown.ModalClose').on('keydown.ModalClose', '.icon-close', function (e) {
      if (e.keyCode === 13 || e.key === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        vex.close(vexInstance);
      }
    });
  }

  getRequestBody (el) {
    try {
      const body = el.data('body');
      return typeof body === "string" ? JSON.parse(el.data('body')) : body;
    } catch (e) {
      return {};
    }
  }

  openAjaxContent(el) {
    let ctx = this;
    let url = el.data('href') || el.attr('href');
    let title = el.data('title');
    let close = el.data('closeText');
    let ariaClose = el.data('ariaCloseText');
    let overlayClass = el.data('overlayClass');
    let overflow = el.data('overflow');
    let dataType = el.data('type');
    let dataEgonValidation = el.data('egonValidation');
    let modules = el.data('modules');
    let method = el.data('method') || 'GET';
    let body = method.toUpperCase() === 'POST' ? this.getRequestBody(el) : null;

    $.ajax({
      type: method,
      url: url,
      data: body,
      dataType: dataType,
      contentType: body ? "application/json; charset=utf-8" : undefined,
    }).then(resp => {
      let chunked = $(resp).find('[data-ajax-chunk]');

      if (typeof resp !="object" && chunked.length) {
        resp = chunked.html();
      }

      vex.open({
        unsafeContent: this.wrappedContent(resp, title)[0].outerHTML,
        className: el.data('modalClass'),
        afterOpen: function() {
          setTimeout(function(){
            $('body').trigger("formInitializeAll");
          }, 1000);
          ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
          ctx.modalAfterOpen(this, close, overflow, ariaClose);
          if (dataEgonValidation === true) {
            ctx.$emit(ctx.$customEvents.MODAL_EVENTS.egonValidation);
          }
          if (modules != undefined) {
            ctx.importDynamicComponents(modules);
          }
        },
        afterClose: function() {
          ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
          $('body').removeClass(ctx.CLASSES.canScroll);
          el.removeClass(ctx.CLASSES.clicked);
          if (ctx._focusTrapHandler) {
            removeTrapFocusOnModal($(this.rootEl)[0], ctx._focusTrapHandler);
            ctx._focusTrapHandler = null;
          }
        },
        overlayClassName: overlayClass
      });
    });
  }

  openStaticContent(el) {
    let ctx = this;
    let title = el.data('title');
    let close = el.data('closeText');
    let ariaClose = el.data('ariaCloseText');
    let content = $(el.data('modalId'))[0].outerHTML;

    vex.open({
      unsafeContent: this.wrappedContent(content, title)[0].outerHTML,
      className: el.data('modalClass'),
      afterOpen: function() {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
        ctx.modalAfterOpen(this, close, null, ariaClose);
      },
      afterClose: function() {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
        $('body').removeClass(ctx.CLASSES.canScroll);
        el.removeClass(ctx.CLASSES.clicked);
      }
    });
  }

  openRemoteContent(conf) {
    let title = $(conf.unsafeContent).data('title');
    let close = $(conf.unsafeContent).data('closeText');
    let ariaClose = $(conf.unsafeContent).data('ariaCloseText');
    const ctx = this;
    let classData = $(conf.unsafeContent).data('modalClass');
    if(conf.modalClass){
      classData = conf.modalClass ;
    }
    if (conf.canScroll) document.body.classList.add(this.CLASSES.canScroll);
    vex.open({
      unsafeContent: this.wrappedContent(conf.unsafeContent, title)[0].outerHTML,
      className: classData,
      afterOpen: function () {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterOpen);
        ctx.modalAfterOpen(this, close, null, ariaClose);
      },
      afterClose: function () {
        ctx.$emit(ctx.$customEvents.MODAL_EVENTS.afterClose, this);
        $('body').removeClass(ctx.CLASSES.canScroll);
      }
    });
  }

  wrappedContent(content, title) {
    let container = $(`<div class="modal-content"></div>`);
    if (title) {
      let $header = $(`<div class="modal-header"><h2 class="h2-tertiary">${title}</div>`);
      container.append($header);
    } else {
      container.addClass('no-header')
    }
    if (content) {
      let $body = $(`<div class="modal-body">${content}</div>`);
      container.append($body);
    }
    return container;
  }
  importDynamicComponents(modulesList) {
    let ctx = this;
    this.loadedComponents = [];
    let modules = modulesList.split(',');
    if (modules.length > 0) {
      modules.forEach(function (module) {
        ctx.importComponents(module)
          .then(({default: module}) => {
            if (!ctx.loadedComponents.includes(module))
            {
              let component = new module(module);
              component.render();
              ctx.loadedComponents.push(module);
            }
          })
          .catch(error => {
            console.error("Failed to load the component", error.stack);
          });
      });
    }
  }

  importComponents(componentName) {
    return import(`../components/${componentName}`);
  }

  bindEvents() {
    let ctx = this;
    this.$on('click.modal', ({event}) => {
      event.preventDefault();
      if (event.currentTarget.classList.contains(ctx.CLASSES.clicked)) return false;
      event.currentTarget.classList.add(ctx.CLASSES.clicked);
      let $el = $(event.currentTarget);
      if ($el.data("originalEvent") !== "run") {
        event.preventDefault();
      }
      if ($el.data('modalId')) {
        this.openStaticContent($el);
      } else {
        this.openAjaxContent($el);
      }
    }, 'body', this.SELECTORS.trigger);

    // Modal when clicking a button/link with data-href
    // $(this.SELECTORS.trigger).on('click.modal', (e) => {
    //   e.preventDefault();
    //   let $el = $(e.currentTarget);
    //   if ($el.data('modalId') ) {
    //     ctx.openStaticContent($el);
    //   } else {
    //     ctx.openAjaxContent($el);
    //   }
    // });

    window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        location.reload();
      }
    });

    // Modal when calling from outside
    this.$on(this.$customEvents.MODAL_EVENTS.show, ({payload}) => {
      this.openRemoteContent(payload);
    });
  }

  render() {
    this.bindEvents();
  }
}
